const BIMONTHLY = 'BIMONTHLY';
const BIWEEKLY = 'BIWEEKLY';
const DAILY = 'DAILY';
const HOURLY = 'HOURLY';
const MONTHLY = 'MONTHLY';
const ONCE = 'ONCE';
const QUARTERLY = 'QUARTERLY';
const SEASONAL = 'SEASONAL';
const TWICE_YEARLY = 'SEMI_ANNUALLY';
const UNSPECIFIED = 'UNSPECIFIED';
const WEEKLY = 'WEEKLY';
const YEARLY = 'YEARLY';


export const FREQUENCY_TYPES = {
    BIMONTHLY,
    BIWEEKLY,
    DAILY,
    HOURLY,
    MONTHLY,
    ONCE,
    QUARTERLY,
    SEASONAL,
    TWICE_YEARLY,
    UNSPECIFIED,
    WEEKLY,
    YEARLY,
};